<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="mb-2">
        <b-col
          cols="12"
          class="mb-1"
        >
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="searchKeyword"
              :placeholder="$t('projects.index.searchPlaceholder')"
            />
            <b-button
              v-if="$can('read', 'PROJECTS_ADD')"
              variant="primary"
              :to="$route.path + '/add'"
              class="text-nowrap ml-2"
            >
              <FeatherIcon icon="PlusIcon" /> {{ $t('common.create') }}
            </b-button>
          </div>
        </b-col>
        <b-col
          cols="12"
        >
          <b-row>
            <b-col>
              <b-row>
                <b-col
                  cols="6"
                  md="4"
                >
                  <b-form-group
                    :label="$t('fields.department')"
                    label-for="department"
                  >
                    <v-select
                      id="department"
                      v-model="filterDepartmentId"
                      :options="departmentOptions"
                      :reduce="o => o.value"
                      :placeholder="$t('fields.department')"
                      clearable
                      @input="onDepartmentChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  md="4"
                >
                  <b-form-group
                    :label="$t('fields.team')"
                    label-for="team"
                  >
                    <v-select
                      id="team"
                      v-model="filterTeamId"
                      :options="filteredTeamOptions"
                      :reduce="o => o.value"
                      :placeholder="$t('fields.team')"
                      clearable
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  md="4"
                >

                  <b-form-group
                    :label="$t('projects.index.created')"
                    label-for="filterCreatedStart"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        id="filterCreatedStart"
                        v-model="filterCreatedStart"
                        v-bind="datepickerProps"
                        :placeholder="$t('projects.index.startDate')"
                        @change="onFilterChange"
                      />
                      <b-input-group-append is-text>
                        -
                      </b-input-group-append>
                      <b-form-datepicker
                        id="filterCreatedEnd"
                        v-model="filterCreatedEnd"
                        v-bind="datepickerProps"
                        :placeholder="$t('projects.index.endDate')"
                        @change="onFilterChange"
                      />
                    </b-input-group>
                  </b-form-group>

                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="auto"
              class="d-flex align-items-center"
            >
              <b-button
                variant="warning"
                class="text-nowrap"
                @click="onFilterChange"
              >
                <FeatherIcon icon="FilterIcon" /> {{ $t('common.filter') }}
              </b-button>
              <b-button
                variant="light"
                class="text-nowrap ml-1"
                @click="clearFilters"
              >
                <FeatherIcon icon="XIcon" /> {{ $t('common.clear') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
    <b-tabs
      v-model="activeTab"
      pills
      nav-class="mx-2"
      @input="onTabChange"
    >
      <b-tab title-item-class="text-nowrap">
        <template #title>
          <div>
            <FeatherIcon icon="ActivityIcon" />
            {{ $t('projects.index.tabs.open') }}
          </div>
        </template>
        <projects-table
          :data-list="dataList"
          :loading="loading"
          :empty-text="emptyText"
          :current-page.sync="currentPage"
          :per-page="perPage"
          :data-counts="dataCounts"
          :status-filter="'open'"
          @get-data="getDataList"
          @remove="removeData"
          @complete="openCompleteModal"
          @cancel="openCancelModal"
        />
      </b-tab>
      <b-tab title-item-class="text-nowrap">
        <template #title>
          <div>
            <FeatherIcon icon="CheckCircleIcon" />
            {{ $t('projects.index.tabs.completed') }}
          </div>
        </template>
        <projects-table
          :data-list="dataList"
          :loading="loading"
          :empty-text="emptyText"
          :current-page.sync="currentPage"
          :per-page="perPage"
          :data-counts="dataCounts"
          :status-filter="'completed'"
          @get-data="getDataList"
          @remove="removeData"
        />
      </b-tab>
      <b-tab title-item-class="text-nowrap">
        <template #title>
          <div>
            <FeatherIcon icon="XCircleIcon" />
            {{ $t('projects.index.tabs.cancelled') }}
          </div>
        </template>
        <projects-table
          :data-list="dataList"
          :loading="loading"
          :empty-text="emptyText"
          :current-page.sync="currentPage"
          :per-page="perPage"
          :data-counts="dataCounts"
          :status-filter="'cancelled'"
          @get-data="getDataList"
          @remove="removeData"
        />
      </b-tab>
    </b-tabs>

    <!-- Tamamlama Modalı -->
    <b-modal
      v-model="completeModal"
      :title="$t('projects.completeModal.title')"
      no-close-on-backdrop
      no-close-on-esc
      centered
      @hidden="onCompleteModalHidden"
    >
      <label class="font-weight-bold">{{ $t('projects.completeModal.closingNote') }} <span class="text-danger">*</span></label>
      <b-form-textarea
        v-model="closingNote"
        rows="4"
        :placeholder="$t('projects.completeModal.placeholder')"
        :state="closingNoteError ? false : null"
      />
      <b-form-invalid-feedback :state="!closingNoteError">
        {{ closingNoteError }}
      </b-form-invalid-feedback>
      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          :disabled="actionSaving"
          @click="completeModal = false"
        >
          {{ $t('projects.modal.dismiss') }}
        </b-button>
        <b-button
          variant="success"
          :disabled="actionSaving"
          @click="submitComplete"
        >
          <b-spinner
            v-if="actionSaving"
            small
            class="mr-1"
          />
          {{ $t('projects.completeModal.submit') }}
        </b-button>
      </template>
    </b-modal>

    <!-- İptal Modalı -->
    <b-modal
      v-model="cancelModal"
      :title="$t('projects.cancelModal.title')"
      no-close-on-backdrop
      no-close-on-esc
      centered
      @hidden="onCancelModalHidden"
    >
      <label class="font-weight-bold">{{ $t('projects.cancelModal.reason') }} <span class="text-danger">*</span></label>
      <b-form-textarea
        v-model="cancelReason"
        rows="4"
        :placeholder="$t('projects.cancelModal.placeholder')"
        :state="cancelReasonError ? false : null"
      />
      <b-form-invalid-feedback :state="!cancelReasonError">
        {{ cancelReasonError }}
      </b-form-invalid-feedback>
      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          :disabled="actionSaving"
          @click="cancelModal = false"
        >
          {{ $t('projects.modal.dismiss') }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="actionSaving"
          @click="submitCancel"
        >
          <b-spinner
            v-if="actionSaving"
            small
            class="mr-1"
          />
          {{ $t('projects.cancelModal.submit') }}
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BTabs, BTab, BRow, BCol, BFormInput, BButton,
  BModal, BFormTextarea, BFormInvalidFeedback, BSpinner, BFormGroup, BFormDatepicker, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProjectsTable from '@/views/Projects/Components/ProjectsTable.vue'
import { datepickerLocale } from '@/libs/i18n/datepicker'
import { definitionId, statusSlug } from '@/libs/definitions'

const tableName = 'projects'
const PER_PAGE = 12

export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTabs,
    BTab,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BFormInvalidFeedback,
    BSpinner,
    BFormGroup,
    vSelect,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    ProjectsTable,
  },
  mixins: [datepickerLocale],
  data() {
    return {
      activeTab: 0,
      searchKeyword: '',
      searchDebounce: null,
      currentPage: 1,
      perPage: PER_PAGE,
      // Filtreler
      filterDepartmentId: null,
      filterTeamId: null,
      filterCreatedStart: null,
      filterCreatedEnd: null,
      // Modal state
      completeModal: false,
      cancelModal: false,
      selectedProjectId: null,
      closingNote: '',
      closingNoteError: null,
      cancelReason: '',
      cancelReasonError: null,
      actionSaving: false,
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.id_users AS id_users`,
          `${tableName}.is_public AS is_public`,
          `${tableName}.id_manager_users AS id_manager_users`,
          `${tableName}.title AS title`,
          `${tableName}.description AS description`,
          `${tableName}.target_date AS target_date`,
          'project_statuses.title AS status',
          `${tableName}.completed_date AS completed_date`,
          `${tableName}.cancelled_date AS cancelled_date`,
          `${tableName}.modified AS modified`,
          `${tableName}.created AS created`,
          'departments.title AS department',
          'teams.title AS team',
          'users.name AS username',
        ],
        where: {
          'projects.id_project_statuses': definitionId('project', 'open'),
        },
        keywords: null,
        limit: PER_PAGE,
        start: 0,
      },
    }
  },
  computed: {
    loading() {
      return this.$store.getters['projects/loading']
    },
    emptyText() {
      if (this.loading === true) return this.$t('common.pleaseWait')
      if (this.dataList.length === 0) return this.$t('common.noData')
      return null
    },
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
    statusFilter() {
      const slug = ['open', 'completed', 'cancelled'][this.activeTab]
      return slug ? definitionId('project', slug) : undefined
    },
    departmentOptions() {
      const list = this.$store.getters['departments/dataList'] || []
      return list.map(d => ({ label: d.title, value: d.id }))
    },
    teamOptions() {
      const list = this.$store.getters['teams/dataList'] || []
      return list.map(t => ({ label: t.title, value: t.id, id_departments: t.id_departments }))
    },
    filteredTeamOptions() {
      if (!this.filterDepartmentId) return this.teamOptions
      return this.teamOptions.filter(t => t.id_departments === this.filterDepartmentId)
    },
  },
  watch: {
    searchKeyword(val) {
      clearTimeout(this.searchDebounce)
      if (val && val.length === 1) return
      this.searchDebounce = setTimeout(() => {
        if (val) {
          this.dataQuery.or_like = { 'projects.title': val }
        } else {
          delete this.dataQuery.or_like
        }
        this.reloadFirstPage()
      }, 400)
    },
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.$store.dispatch('departments/getDataList', {})
    this.$store.dispatch('teams/getDataList', {})
    this.getDataList()
  },
  methods: {
    // Sayfa 1 değilse değişiklik currentPage izleyicisiyle tek istek atar.
    reloadFirstPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.dataQuery.start = 0
      this.getDataList()
    },
    onTabChange() {
      this.reloadFirstPage()
    },
    onDepartmentChange() {
      this.filterTeamId = null
    },
    onFilterChange() {
      this.reloadFirstPage()
    },
    clearFilters() {
      this.filterDepartmentId = null
      this.filterTeamId = null
      this.filterCreatedStart = null
      this.filterCreatedEnd = null
      // Arama doluysa boşaltmak izleyici üzerinden listeyi yeniler.
      if (this.searchKeyword) {
        this.searchKeyword = ''
      } else {
        this.reloadFirstPage()
      }
    },
    getDataList() {
      this.dataQuery.where = {
        'projects.id_project_statuses': this.statusFilter,
      }
      if (this.filterDepartmentId) {
        this.dataQuery.where['projects.id_departments'] = this.filterDepartmentId
      }
      if (this.filterTeamId) {
        this.dataQuery.where['projects.id_teams'] = this.filterTeamId
      }
      this.dataQuery.date_range = {
        created_start: this.filterCreatedStart || null,
        created_end: this.filterCreatedEnd || null,
      }
      this.$store.dispatch('projects/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$t('alerts.remove.title'),
        text: this.$t('alerts.remove.message'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('alerts.remove.confirm'),
        cancelButtonText: this.$t('alerts.remove.cancel'),
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projects/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$t('alerts.remove.resultTitle'),
            text: this.$t('alerts.remove.resultMessage'),
            confirmButtonText: this.$t('alerts.remove.resultClose'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    async openCompleteModal(item) {
      const fresh = await this.$store.dispatch('projects/getDataItem', item.id)
      if (!fresh || statusSlug('project', fresh) !== 'open') {
        this.showToast({
          variant: 'warning',
          title: this.$t('common.toast.warning'),
          icon: 'AlertTriangleIcon',
          text: this.$t('projects.index.notOpen'),
        })
        this.getDataList()
        return
      }
      this.selectedProjectId = item.id
      this.closingNote = ''
      this.closingNoteError = null
      this.completeModal = true
    },
    async submitComplete() {
      this.closingNoteError = null
      if (!this.closingNote.trim()) {
        this.closingNoteError = this.$t('projects.completeModal.required')
        return
      }
      this.actionSaving = true
      try {
        const res = await this.$store.dispatch('projects/completeProject', {
          id: this.selectedProjectId,
          closing_note: this.closingNote.trim(),
        })
        if (res?.status === false) {
          this.closingNoteError = res?.errors?.closing_note || res?.message
          return
        }
        this.showToast({
          variant: 'success', title: this.$t('common.toast.successShort'), icon: 'CheckIcon', text: this.$t('projects.index.completed'),
        })
        this.completeModal = false
        this.getDataList()
      } finally {
        this.actionSaving = false
      }
    },
    onCompleteModalHidden() {
      this.closingNote = ''
      this.closingNoteError = null
      this.selectedProjectId = null
    },
    async openCancelModal(item) {
      const fresh = await this.$store.dispatch('projects/getDataItem', item.id)
      if (!fresh || statusSlug('project', fresh) !== 'open') {
        this.showToast({
          variant: 'warning',
          title: this.$t('common.toast.warning'),
          icon: 'AlertTriangleIcon',
          text: this.$t('projects.index.notOpen'),
        })
        this.getDataList()
        return
      }
      this.selectedProjectId = item.id
      this.cancelReason = ''
      this.cancelReasonError = null
      this.cancelModal = true
    },
    async submitCancel() {
      this.cancelReasonError = null
      if (!this.cancelReason.trim()) {
        this.cancelReasonError = this.$t('projects.cancelModal.required')
        return
      }
      this.actionSaving = true
      try {
        const res = await this.$store.dispatch('projects/cancelProject', {
          id: this.selectedProjectId,
          cancel_reason: this.cancelReason.trim(),
        })
        if (res?.status === false) {
          this.cancelReasonError = res?.errors?.cancel_reason || res?.message
          return
        }
        this.showToast({
          variant: 'success', title: this.$t('common.toast.successShort'), icon: 'CheckIcon', text: this.$t('projects.index.cancelled'),
        })
        this.cancelModal = false
        this.getDataList()
      } finally {
        this.actionSaving = false
      }
    },
    onCancelModalHidden() {
      this.cancelReason = ''
      this.cancelReasonError = null
      this.selectedProjectId = null
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
